/** Superficie pública de shared/data. */
export { usePaginatedRemoteList } from './usePaginatedRemoteList';
export type { PaginatedListPageSize, UsePaginatedRemoteListParams } from './usePaginatedRemoteList';
